import { ApolloLink } from "@apollo/client"

import { QueryTiming, QueryTimingCallback } from "../context"

const redactedResponseOperationNames = new Set(["GetDataSourceLoginPassword"])

const redactResponseIfNeeded = (
	operationName: string,
	response: unknown
): unknown => {
	if (!redactedResponseOperationNames.has(operationName)) return response
	return {
		...((response as Record<string, unknown>) ?? {}),
		data: "[REDACTED]",
	}
}

// NOTE: context が any 型になるせいで any 型が多い
export const queryTimingLink = new ApolloLink((operation, forward) => {
	const startTime = performance.now()
	const operationName = operation.operationName || "unknown"

	const context = operation.getContext()
	const fetchOptions = context.fetchOptions
	const requestId = fetchOptions?.requestId

	// TODO: forward が2個以上 response 返す場合どうするべきか考える
	return forward(operation).map((response) => {
		const endTime = performance.now()
		const tookMilliseconds = endTime - startTime

		const queryTimingCallback: QueryTimingCallback | undefined =
			context.queryTimingCallback

		const timing: QueryTiming = {
			operationName,
			tookMilliseconds,
			startTime,
			endTime,
			requestId,
			variables: operation.variables,
			response: redactResponseIfNeeded(operationName, response),
		}

		if (queryTimingCallback) {
			queryTimingCallback(timing)
		}

		return response
	})
})
